module.exports = __webpack_public_path__ + "static/img/蒙版@2x.11c45a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achievements/蒙版@2x.png
// module id = 3t8G
// module chunks = 1